<template>
  <div class="">
    <headerBar :activeIndex="activeIndex"></headerBar>
    <banner :carousel="info.carousel" :Mcarousel="info.Mcarousel"></banner>
    <div class="environment">
      <div class="pc">
        <div
          style="
            width: 100%;
            line-height: 30px;
            margin-top: 40px;
            position: relative;
          "
        >
          <img
            src="../assets/wenzibeijin.png"
            alt=""
            style="
              position: absolute;
              top: -150px;
              width: 100%;
              left: 0;
              z-index: -1;
            "
          />
        </div>
        <div class="main-content">
          <div style="width: 100%; margin: 0 auto">
            <img src="../assets/wuyan.png" alt="" style="width: 100%" />
          </div>
          <div class="flex-center" style="margin: 20px 0">
            <div style="flex: 1; text-align: center">
              <div
                :class="'select-bar1 ' + (type === `1` ? 'select-bg1' : '')"
                @click="changeType('1')"
              >
                医院环境
              </div>
            </div>
            <div style="flex: 1; text-align: center">
              <div
                :class="'select-bar1 ' + (type === `2` ? 'select-bg1' : '')"
                @click="changeType('2')"
              >
                医疗设备
              </div>
            </div>
          </div>
          <div style="padding: 15px 60px" v-loading="loading">
            <div>
              <span v-if="type === `1`">{{ info.environment_desc }}</span>
              <span v-if="type === `2`">{{ info.equipment_desc }}</span>
            </div>
            <div class="" style="margin-top: 40px" v-if="type === `1`">
              <div
                class="environmentImage"
                v-for="(item, index) of info.environment_images"
                :key="index"
              >
                <div class="img-border">
                  <div style="">
                    <img
                      :src="`${item}`"
                      alt=""
                      style="
                        width: 100%;
                        height: 200px;
                        margin: 10px 12px;
                        margin-top: 12px;
                      "
                    />
                  </div>
                </div>
                <div class="img-text" style="text-align: center">
                  {{ imageText[index] }}
                </div>
              </div>
            </div>
            <div class="" style="margin-top: 40px" v-if="type === `2`">
              <div
                class="environmentImage"
                v-for="(item, index) of info.equipment_images"
                :key="index"
              >
                <div class="img-border">
                  <div style="">
                    <img
                      :src="`${item}`"
                      alt=""
                      style="
                        width: 100%;
                        height: 200px;
                        margin: 10px 12px;
                        margin-top: 12px;
                      "
                    />
                  </div>
                </div>
                <div class="img-text" style="text-align: center">
                  {{ imageText[index] }}
                </div>
              </div>
            </div>
            <div style="clear: both"></div>
          </div>
        </div>
      </div>
      <div class="mobile">
        <div class="flex-center" style="margin: 20px 0; zoom: 0.7">
          <div style="flex: 1; text-align: center">
            <div
              :class="'select-bar1 ' + (type === `1` ? 'select-bg1' : '')"
              @click="changeType('1')"
            >
              医院环境
            </div>
          </div>
          <div style="flex: 1; text-align: center">
            <div
              :class="'select-bar1 ' + (type === `2` ? 'select-bg1' : '')"
              @click="changeType('2')"
            >
              医疗设备
            </div>
          </div>
        </div>
        <div style="padding: 0 0.1rem; font-size: 0.14rem" v-loading="loading">
          <div>
            <span v-if="type === `1`">{{ info.environment_desc }}</span>
            <span v-if="type === `2`">{{ info.equipment_desc }}</span>
          </div>
          <div class="" style="margin-top: 40px" v-if="type === `1`">
            <div
              class="environmentImage"
              v-for="(item, index) of info.environment_images"
              :key="index"
            >
              <div class="img-border">
                <div style="">
                  <img :src="`${item}`" alt="" @click="showPhoto(index)" />
                </div>
              </div>
              <div class="img-text" style="text-align: center">
                {{ imageText[index] }}
              </div>
            </div>
          </div>
          <div class="" style="margin-top: 40px" v-if="type === `2`">
            <div
              class="environmentImage"
              v-for="(item, index) of info.equipment_images"
              :key="index"
            >
              <div class="img-border">
                <div style="">
                  <img :src="`${item}`" alt="" @click="showPhoto(index)" />
                </div>
              </div>
              <div class="img-text" style="text-align: center">
                {{ imageText[index] }}
              </div>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
    <footerBar></footerBar>
  </div>
</template>

<script>
import banner from "@/components/banner";
import headerBar from "@/components/header";
import footerBar from "@/components/footer";
import { getmenudetail } from "@/api/common";
import { ImagePreview } from "vant";
export default {
  name: "environment",
  components: { banner, footerBar, headerBar },
  data() {
    return {
      activeIndex: "environment",
      info: { carousel: "", Mcarousel: "" },
      type: 1,
      imageList: [],
      imageText: [],
      loading: false,
    };
  },
  mounted() {
    this.loading = true;
    getmenudetail({ id: 4 }).then((res) => {
      this.loading = false;
      if (res.data.banner_pc_images && res.data.banner_pc_images !== "") {
        res.data.carousel = res.data.banner_pc_images.split(",");
        res.data.Mcarousel = res.data.banner_mobile_images.split(",");
      }
      this.info = res.data;
      this.changeType("1");
      this.postMessage(
        "东莞黄家圣幸中医医院环境",
        this.info.environment_desc,
        window.location.href,
        res.data.carousel[0]
      );
    });
  },
  methods: {
    changeType(type) {
      this.type = type;
      if (type === "1") {
        this.imageList = this.info.environment_images;
        this.imageText = this.info.environment_titles;
      } else if (type === "2") {
        this.imageList = this.info.equipment_images;
        this.imageText = this.info.equipment_titles;
      }
    },
    // 预览图片 vant组件
    showPhoto(index) {
      ImagePreview({
        images: this.imageList,
        startPosition: index,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.environment .select-bg1 {
  background-image: url(../assets/textBg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 80px;
  line-height: 80px;
  color: #e5e5e5;
  font-weight: 400 !important;
  /* 淡出动画 */
  /* animation: fade-in; */
  /*动画持续时间*/
  /* animation-duration: 0.5s; */
  /*针对webkit内核*/
  /* -webkit-animation: fade-in 0.5s; */
}
.environment .select-bar1 {
  width: 150px;
  margin: 0 auto;
  padding: 0 50px 0 0;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
}
.environment .img-border {
  background-image: url(../assets/border.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #e5e5e5;
  width: 100%;
  transition: all 0.5s;
}
.environment .img-border > div {
  width: calc(100% - 24px);
}
.environment .img-border:hover {
  transform: scale(1.1);
}
.environment .img-text {
  margin-top: 8px;
  color: #ad4b1c;
  font-size: 16px;
}
.environment .environmentImage {
  float: left;
  width: calc((100% - 200px) / 3);
  margin-right: 100px;
  margin-top: 10px;
}
.environment .pc .environmentImage:nth-child(3n) {
  margin-right: 0;
}
.environment .pc .environmentImage img {
  width: 100%;
  height: 200px;
  margin: 10px 12px;
  margin-top: 12px;
}
@media screen and (max-width: 750px) {
  .environment .mobile {
  }

  .environment .environmentImage {
    float: left;
    width: calc((100% - 0.3rem) / 2);
    margin-right: 0.3rem;
    margin-top: 10px;
  }
  .environment .environmentImage:nth-child(2n) {
    margin-right: 0;
  }
  .environment .mobile .img-border {
    background-image: url(../assets/border.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: #e5e5e5;
    width: 100%;
    transition: all 0.5s;
  }
  .environment .mobile .environmentImage img {
    width: 100%;
    height: 1rem;
    margin: 0.08rem;
  }
  .environment .img-text {
    margin-top: 8px;
    color: #ad4b1c;
    font-size: 0.12rem;
  }
  .environment .img-border > div {
    width: calc(100% - 0.16rem);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/environment.vue